import { DELETE_SESSION_MUTATION } from "@graphql"
import { useMutation } from "@apollo/client"

const useDeleteSession = () => {
  const [deleteSession, {data, loading, error}] = useMutation(DELETE_SESSION_MUTATION)

  return {
    deleteSession,
    data,
    loading,
    error,
  }
}

export default useDeleteSession